var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 975,
    height: 906,
    viewBox: "0 0 975 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_50_1125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7037,
    height: 598.773,
    transform: "matrix(0.644526 0.764583 -0.765013 0.644014 707.135 248.899)",
    fill: "url(#paint0_linear_50_1125)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_50_1125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3592,
    height: 257.36,
    transform: "matrix(0.644526 0.764583 -0.765013 0.644014 684.342 272.887)",
    fill: "url(#paint1_linear_50_1125)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.6
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M462.219 510.981C462.483 510.809 462.559 510.455 462.387 510.19C462.215 509.925 461.862 509.85 461.598 510.022C461.333 510.194 461.258 510.548 461.429 510.812C461.601 511.077 461.954 511.152 462.219 510.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.478 512.605C465.676 512.476 465.732 512.211 465.604 512.013C465.475 511.814 465.21 511.758 465.012 511.886C464.814 512.015 464.757 512.281 464.886 512.479C465.015 512.678 465.28 512.734 465.478 512.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.117 502.445C470.316 502.316 470.372 502.051 470.243 501.852C470.115 501.654 469.85 501.597 469.651 501.726C469.453 501.855 469.397 502.12 469.525 502.319C469.654 502.517 469.919 502.573 470.117 502.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.466 515.18C449.664 515.051 449.721 514.786 449.592 514.587C449.463 514.389 449.198 514.332 449 514.461C448.802 514.59 448.746 514.855 448.874 515.053C449.003 515.252 449.268 515.308 449.466 515.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M441.348 528.626C441.612 528.454 441.688 528.101 441.516 527.836C441.345 527.571 440.991 527.496 440.727 527.668C440.462 527.839 440.387 528.193 440.559 528.458C440.73 528.723 441.084 528.798 441.348 528.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.386 526.309C433.518 526.223 433.556 526.046 433.47 525.914C433.384 525.782 433.208 525.744 433.076 525.83C432.944 525.916 432.906 526.093 432.992 526.225C433.077 526.357 433.254 526.395 433.386 526.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.554 520.791C467.686 520.705 467.724 520.529 467.638 520.396C467.552 520.264 467.376 520.226 467.244 520.312C467.111 520.398 467.074 520.575 467.16 520.707C467.245 520.839 467.422 520.877 467.554 520.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.719 486.897C519.851 486.811 519.889 486.635 519.803 486.502C519.717 486.37 519.541 486.332 519.409 486.418C519.277 486.504 519.239 486.681 519.325 486.813C519.41 486.945 519.587 486.983 519.719 486.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.414 457.012C537.547 456.926 537.584 456.75 537.498 456.617C537.413 456.485 537.236 456.447 537.104 456.533C536.972 456.619 536.934 456.796 537.02 456.928C537.106 457.06 537.282 457.098 537.414 457.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.083 468.438C558.215 468.352 558.253 468.175 558.167 468.043C558.082 467.911 557.905 467.873 557.773 467.959C557.641 468.045 557.603 468.221 557.689 468.354C557.775 468.486 557.951 468.524 558.083 468.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.991 566.576C384.123 566.49 384.16 566.313 384.075 566.181C383.989 566.049 383.812 566.011 383.68 566.097C383.548 566.183 383.511 566.36 383.596 566.492C383.682 566.624 383.859 566.662 383.991 566.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M372.019 555.97C372.151 555.884 372.189 555.707 372.103 555.575C372.017 555.442 371.84 555.405 371.708 555.491C371.576 555.577 371.539 555.753 371.624 555.886C371.71 556.018 371.887 556.055 372.019 555.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M365.302 568.165C365.434 568.079 365.472 567.903 365.386 567.77C365.3 567.638 365.124 567.601 364.992 567.686C364.86 567.772 364.822 567.949 364.908 568.081C364.993 568.213 365.17 568.251 365.302 568.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M382.515 577.41C382.647 577.324 382.685 577.147 382.599 577.015C382.513 576.883 382.337 576.845 382.205 576.931C382.073 577.017 382.035 577.194 382.121 577.326C382.206 577.458 382.383 577.496 382.515 577.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M433.249 530.823C433.381 530.737 433.419 530.56 433.333 530.428C433.248 530.296 433.071 530.258 432.939 530.344C432.807 530.43 432.769 530.607 432.855 530.739C432.941 530.871 433.117 530.909 433.249 530.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M472.669 529.727C472.801 529.641 472.839 529.464 472.753 529.332C472.668 529.199 472.491 529.162 472.359 529.248C472.227 529.334 472.189 529.51 472.275 529.643C472.361 529.775 472.537 529.812 472.669 529.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M517.056 497.479C517.188 497.394 517.226 497.217 517.14 497.084C517.054 496.952 516.878 496.915 516.746 497C516.614 497.086 516.576 497.263 516.662 497.395C516.747 497.528 516.924 497.565 517.056 497.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M391.117 553.434C391.249 553.348 391.287 553.171 391.201 553.039C391.116 552.907 390.939 552.869 390.807 552.955C390.675 553.041 390.637 553.218 390.723 553.35C390.809 553.482 390.985 553.52 391.117 553.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.766 504.737C437.898 504.651 437.936 504.474 437.85 504.342C437.764 504.209 437.588 504.172 437.456 504.258C437.324 504.343 437.286 504.52 437.372 504.652C437.457 504.785 437.634 504.822 437.766 504.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.305 480.315C474.437 480.229 474.475 480.052 474.389 479.92C474.303 479.787 474.127 479.75 473.995 479.836C473.863 479.921 473.825 480.098 473.911 480.231C473.996 480.363 474.173 480.4 474.305 480.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.781 537.351C435.913 537.265 435.951 537.088 435.865 536.956C435.779 536.824 435.603 536.786 435.47 536.872C435.338 536.958 435.301 537.134 435.387 537.267C435.472 537.399 435.649 537.437 435.781 537.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M419.031 548.235C419.163 548.149 419.2 547.973 419.115 547.84C419.029 547.708 418.852 547.67 418.72 547.756C418.588 547.842 418.551 548.019 418.636 548.151C418.722 548.283 418.899 548.321 419.031 548.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M389.785 546.129C389.918 546.043 389.955 545.866 389.869 545.734C389.784 545.602 389.607 545.564 389.475 545.65C389.343 545.736 389.305 545.912 389.391 546.045C389.477 546.177 389.653 546.215 389.785 546.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M445.802 507.687C445.934 507.601 445.972 507.425 445.886 507.292C445.8 507.16 445.624 507.122 445.492 507.208C445.36 507.294 445.322 507.471 445.408 507.603C445.493 507.735 445.67 507.773 445.802 507.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M442.801 539.26C442.933 539.174 442.971 538.997 442.885 538.865C442.799 538.733 442.623 538.695 442.491 538.781C442.359 538.867 442.321 539.044 442.407 539.176C442.492 539.308 442.669 539.346 442.801 539.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M415.4 560.468C415.532 560.382 415.569 560.205 415.484 560.073C415.398 559.941 415.221 559.903 415.089 559.989C414.957 560.075 414.919 560.252 415.005 560.384C415.091 560.516 415.267 560.554 415.4 560.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M398.058 548.926C398.19 548.84 398.228 548.663 398.142 548.531C398.056 548.398 397.88 548.361 397.747 548.447C397.615 548.532 397.578 548.709 397.664 548.842C397.749 548.974 397.926 549.011 398.058 548.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M546.422 451.5C546.554 451.414 546.592 451.237 546.506 451.105C546.421 450.973 546.244 450.935 546.112 451.021C545.98 451.107 545.942 451.284 546.028 451.416C546.114 451.548 546.29 451.586 546.422 451.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M501.532 466.708C501.664 466.623 501.701 466.446 501.615 466.314C501.53 466.181 501.353 466.144 501.221 466.229C501.089 466.315 501.051 466.492 501.137 466.624C501.223 466.757 501.399 466.794 501.532 466.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M546.639 465.999C546.771 465.913 546.809 465.736 546.723 465.604C546.637 465.471 546.461 465.434 546.329 465.52C546.197 465.605 546.159 465.782 546.245 465.915C546.33 466.047 546.507 466.084 546.639 465.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M487.497 507.492C487.762 507.321 487.837 506.967 487.665 506.702C487.494 506.437 487.14 506.362 486.876 506.534C486.611 506.705 486.536 507.059 486.708 507.324C486.879 507.589 487.233 507.664 487.497 507.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M496.959 491.131C497.224 490.959 497.299 490.605 497.127 490.341C496.956 490.076 496.602 490.001 496.338 490.172C496.073 490.344 495.998 490.698 496.17 490.963C496.341 491.228 496.695 491.303 496.959 491.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.405 482.824C491.604 482.695 491.66 482.43 491.531 482.231C491.403 482.033 491.138 481.976 490.94 482.105C490.741 482.234 490.685 482.499 490.814 482.698C490.942 482.896 491.207 482.953 491.405 482.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.201 518.708C491.399 518.579 491.455 518.314 491.327 518.115C491.198 517.917 490.933 517.86 490.735 517.989C490.536 518.118 490.48 518.383 490.609 518.582C490.737 518.78 491.002 518.837 491.201 518.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.747 471.88C573.945 471.752 574.001 471.486 573.873 471.288C573.744 471.089 573.479 471.033 573.281 471.162C573.082 471.29 573.026 471.556 573.155 471.754C573.283 471.953 573.548 472.009 573.747 471.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.812 568.713C416.01 568.584 416.066 568.319 415.938 568.12C415.809 567.922 415.544 567.865 415.346 567.994C415.147 568.123 415.091 568.388 415.22 568.587C415.348 568.785 415.613 568.842 415.812 568.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.418 583.881C380.617 583.752 380.673 583.486 380.544 583.288C380.416 583.089 380.151 583.033 379.952 583.162C379.754 583.291 379.698 583.556 379.826 583.754C379.955 583.953 380.22 584.009 380.418 583.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.139 576.94C370.337 576.812 370.394 576.546 370.265 576.348C370.136 576.149 369.871 576.093 369.673 576.222C369.475 576.35 369.418 576.616 369.547 576.814C369.676 577.013 369.941 577.069 370.139 576.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.027 495.078C483.225 494.949 483.281 494.684 483.153 494.485C483.024 494.287 482.759 494.23 482.561 494.359C482.363 494.488 482.306 494.753 482.435 494.952C482.564 495.15 482.829 495.207 483.027 495.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.882 539.86C453.08 539.731 453.137 539.466 453.008 539.268C452.879 539.069 452.614 539.013 452.416 539.141C452.218 539.27 452.162 539.536 452.29 539.734C452.419 539.933 452.684 539.989 452.882 539.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.859 510.983C520.057 510.854 520.113 510.588 519.985 510.39C519.856 510.191 519.591 510.135 519.393 510.264C519.195 510.393 519.138 510.658 519.267 510.856C519.395 511.055 519.66 511.111 519.859 510.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.706 453.489C572.905 453.36 572.961 453.094 572.832 452.896C572.704 452.697 572.439 452.641 572.24 452.77C572.042 452.899 571.986 453.164 572.114 453.362C572.243 453.561 572.508 453.617 572.706 453.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.908 436.58C570.107 436.451 570.163 436.185 570.034 435.987C569.906 435.788 569.641 435.732 569.443 435.861C569.244 435.99 569.188 436.255 569.317 436.453C569.445 436.652 569.71 436.708 569.908 436.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M511.301 470.235C511.565 470.063 511.641 469.71 511.469 469.445C511.297 469.18 510.944 469.105 510.68 469.277C510.415 469.448 510.34 469.802 510.511 470.067C510.683 470.332 511.037 470.407 511.301 470.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.276 453.226C500.54 453.054 500.615 452.7 500.444 452.436C500.272 452.171 499.919 452.096 499.654 452.267C499.39 452.439 499.315 452.793 499.486 453.058C499.658 453.323 500.011 453.398 500.276 453.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.041 467.5C527.24 467.371 527.296 467.106 527.167 466.907C527.039 466.709 526.774 466.652 526.576 466.781C526.377 466.91 526.321 467.175 526.45 467.374C526.578 467.572 526.843 467.629 527.041 467.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M532.591 450.616C532.855 450.444 532.931 450.09 532.759 449.825C532.587 449.56 532.234 449.485 531.97 449.657C531.705 449.829 531.63 450.183 531.802 450.447C531.973 450.712 532.327 450.787 532.591 450.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M567.305 452.233C567.569 452.061 567.644 451.707 567.473 451.442C567.301 451.178 566.948 451.102 566.683 451.274C566.419 451.446 566.344 451.8 566.515 452.064C566.687 452.329 567.04 452.405 567.305 452.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M539.617 470.903C539.882 470.731 539.957 470.377 539.785 470.112C539.614 469.847 539.26 469.772 538.996 469.944C538.732 470.116 538.656 470.47 538.828 470.734C538.999 470.999 539.353 471.074 539.617 470.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M404.909 564.219C405.174 564.047 405.249 563.693 405.077 563.429C404.906 563.164 404.552 563.089 404.288 563.26C404.024 563.432 403.948 563.786 404.12 564.051C404.292 564.316 404.645 564.391 404.909 564.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.986 563.637C377.251 563.465 377.326 563.111 377.154 562.847C376.983 562.582 376.629 562.507 376.365 562.678C376.101 562.85 376.025 563.204 376.197 563.469C376.369 563.734 376.722 563.809 376.986 563.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M552.834 451.42C553.099 451.248 553.174 450.894 553.002 450.63C552.831 450.365 552.477 450.29 552.213 450.461C551.948 450.633 551.873 450.987 552.045 451.252C552.216 451.516 552.57 451.592 552.834 451.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M405.925 533.258C406.189 533.086 406.265 532.732 406.093 532.468C405.921 532.203 405.568 532.128 405.304 532.299C405.039 532.471 404.964 532.825 405.136 533.09C405.307 533.355 405.661 533.43 405.925 533.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M396.359 532.664C396.623 532.492 396.698 532.138 396.527 531.874C396.355 531.609 396.002 531.534 395.737 531.705C395.473 531.877 395.398 532.231 395.569 532.496C395.741 532.761 396.094 532.836 396.359 532.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M404.382 549.241C404.646 549.069 404.722 548.716 404.55 548.451C404.379 548.186 404.025 548.111 403.761 548.283C403.496 548.454 403.421 548.808 403.593 549.073C403.764 549.338 404.118 549.413 404.382 549.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.181 539.285C419.379 539.156 419.436 538.891 419.307 538.692C419.178 538.494 418.913 538.437 418.715 538.566C418.517 538.695 418.46 538.96 418.589 539.159C418.718 539.357 418.983 539.414 419.181 539.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M497.545 384.049C497.809 383.877 497.885 383.523 497.713 383.259C497.542 382.994 497.188 382.918 496.924 383.09C496.659 383.262 496.584 383.616 496.756 383.881C496.927 384.145 497.281 384.221 497.545 384.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.809 385.675C501.007 385.546 501.063 385.28 500.935 385.082C500.806 384.883 500.541 384.827 500.343 384.956C500.144 385.085 500.088 385.35 500.217 385.548C500.345 385.747 500.61 385.803 500.809 385.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.446 375.513C505.644 375.384 505.7 375.119 505.572 374.92C505.443 374.722 505.178 374.665 504.98 374.794C504.781 374.923 504.725 375.188 504.854 375.387C504.982 375.585 505.247 375.642 505.446 375.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.795 388.249C484.993 388.12 485.05 387.855 484.921 387.656C484.793 387.458 484.528 387.401 484.329 387.53C484.131 387.659 484.075 387.924 484.203 388.123C484.332 388.321 484.597 388.378 484.795 388.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M476.677 401.696C476.941 401.524 477.017 401.17 476.845 400.905C476.673 400.64 476.32 400.565 476.056 400.737C475.791 400.909 475.716 401.263 475.887 401.527C476.059 401.792 476.413 401.867 476.677 401.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.715 399.378C468.847 399.292 468.885 399.116 468.799 398.983C468.713 398.851 468.537 398.813 468.405 398.899C468.273 398.985 468.235 399.162 468.321 399.294C468.407 399.426 468.583 399.464 468.715 399.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.882 393.86C503.014 393.775 503.052 393.598 502.966 393.466C502.881 393.333 502.704 393.296 502.572 393.382C502.44 393.467 502.402 393.644 502.488 393.776C502.574 393.909 502.75 393.946 502.882 393.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.048 359.966C555.18 359.881 555.218 359.704 555.132 359.572C555.046 359.439 554.87 359.402 554.738 359.488C554.606 359.573 554.568 359.75 554.654 359.882C554.739 360.015 554.916 360.052 555.048 359.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.743 330.081C572.875 329.996 572.912 329.819 572.827 329.687C572.741 329.554 572.564 329.517 572.432 329.603C572.3 329.688 572.262 329.865 572.348 329.997C572.434 330.13 572.61 330.167 572.743 330.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.412 341.508C593.544 341.422 593.582 341.245 593.496 341.113C593.411 340.981 593.234 340.943 593.102 341.029C592.97 341.115 592.932 341.292 593.018 341.424C593.104 341.556 593.28 341.594 593.412 341.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32 439.644C419.452 439.559 419.489 439.382 419.404 439.249C419.318 439.117 419.141 439.08 419.009 439.165C418.877 439.251 418.84 439.428 418.925 439.56C419.011 439.693 419.188 439.73 419.32 439.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M407.347 429.039C407.479 428.953 407.517 428.776 407.431 428.644C407.345 428.512 407.169 428.474 407.037 428.56C406.905 428.646 406.867 428.823 406.953 428.955C407.039 429.087 407.215 429.125 407.347 429.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M400.63 441.235C400.762 441.149 400.8 440.972 400.714 440.84C400.629 440.707 400.452 440.67 400.32 440.756C400.188 440.842 400.15 441.018 400.236 441.151C400.322 441.283 400.498 441.32 400.63 441.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M417.843 450.479C417.975 450.393 418.013 450.216 417.927 450.084C417.842 449.952 417.665 449.914 417.533 450C417.401 450.086 417.363 450.262 417.449 450.395C417.535 450.527 417.711 450.565 417.843 450.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M468.578 403.891C468.71 403.806 468.748 403.629 468.662 403.496C468.577 403.364 468.4 403.327 468.268 403.412C468.136 403.498 468.098 403.675 468.184 403.807C468.27 403.94 468.446 403.977 468.578 403.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M507.998 402.796C508.13 402.71 508.167 402.533 508.082 402.401C507.996 402.269 507.819 402.231 507.687 402.317C507.555 402.403 507.517 402.58 507.603 402.712C507.689 402.844 507.865 402.882 507.998 402.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M552.384 370.548C552.516 370.462 552.554 370.285 552.468 370.153C552.382 370.021 552.206 369.983 552.074 370.069C551.942 370.155 551.904 370.331 551.99 370.464C552.076 370.596 552.252 370.634 552.384 370.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M426.446 426.503C426.578 426.417 426.616 426.24 426.53 426.108C426.444 425.975 426.268 425.938 426.136 426.024C426.003 426.109 425.966 426.286 426.052 426.418C426.137 426.551 426.314 426.588 426.446 426.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.094 377.805C473.226 377.719 473.264 377.542 473.178 377.41C473.092 377.278 472.916 377.24 472.784 377.326C472.652 377.412 472.614 377.589 472.7 377.721C472.785 377.853 472.962 377.891 473.094 377.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.633 353.383C509.765 353.297 509.803 353.12 509.717 352.988C509.631 352.856 509.455 352.818 509.323 352.904C509.191 352.99 509.153 353.167 509.239 353.299C509.325 353.431 509.501 353.469 509.633 353.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.11 410.42C471.242 410.334 471.279 410.157 471.193 410.025C471.108 409.893 470.931 409.855 470.799 409.941C470.667 410.027 470.629 410.204 470.715 410.336C470.801 410.468 470.977 410.506 471.11 410.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M454.36 421.304C454.492 421.218 454.529 421.041 454.444 420.909C454.358 420.776 454.181 420.739 454.049 420.825C453.917 420.91 453.88 421.087 453.965 421.22C454.051 421.352 454.228 421.389 454.36 421.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M425.114 419.198C425.246 419.112 425.284 418.935 425.198 418.803C425.112 418.671 424.936 418.633 424.803 418.719C424.671 418.805 424.634 418.982 424.72 419.114C424.805 419.246 424.982 419.284 425.114 419.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M481.131 380.757C481.263 380.671 481.301 380.494 481.215 380.362C481.129 380.229 480.953 380.192 480.821 380.278C480.689 380.363 480.651 380.54 480.737 380.673C480.823 380.805 480.999 380.842 481.131 380.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M478.129 412.328C478.261 412.242 478.299 412.065 478.213 411.933C478.128 411.801 477.951 411.763 477.819 411.849C477.687 411.935 477.649 412.112 477.735 412.244C477.821 412.376 477.997 412.414 478.129 412.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M450.728 433.537C450.86 433.451 450.898 433.275 450.812 433.142C450.726 433.01 450.55 432.972 450.418 433.058C450.285 433.144 450.248 433.321 450.334 433.453C450.419 433.585 450.596 433.623 450.728 433.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M433.386 421.995C433.518 421.909 433.556 421.732 433.47 421.6C433.384 421.468 433.208 421.43 433.076 421.516C432.944 421.602 432.906 421.779 432.992 421.911C433.077 422.043 433.254 422.081 433.386 421.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M581.751 324.569C581.883 324.483 581.921 324.307 581.835 324.174C581.749 324.042 581.573 324.005 581.441 324.09C581.309 324.176 581.271 324.353 581.357 324.485C581.443 324.617 581.619 324.655 581.751 324.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M536.86 339.778C536.992 339.692 537.029 339.515 536.944 339.383C536.858 339.251 536.681 339.213 536.549 339.299C536.417 339.385 536.38 339.561 536.465 339.694C536.551 339.826 536.728 339.864 536.86 339.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M581.967 339.068C582.099 338.982 582.137 338.805 582.051 338.673C581.965 338.541 581.789 338.503 581.657 338.589C581.525 338.675 581.487 338.852 581.573 338.984C581.659 339.116 581.835 339.154 581.967 339.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M522.827 380.561C523.092 380.389 523.167 380.035 522.995 379.77C522.824 379.506 522.47 379.43 522.206 379.602C521.942 379.774 521.866 380.128 522.038 380.393C522.209 380.657 522.563 380.733 522.827 380.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M532.286 364.2C532.551 364.029 532.626 363.675 532.454 363.41C532.283 363.145 531.929 363.07 531.665 363.242C531.401 363.414 531.325 363.767 531.497 364.032C531.668 364.297 532.022 364.372 532.286 364.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.734 355.892C526.932 355.764 526.988 355.498 526.86 355.3C526.731 355.101 526.466 355.045 526.268 355.174C526.07 355.302 526.013 355.568 526.142 355.766C526.27 355.965 526.535 356.021 526.734 355.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.53 391.776C526.728 391.647 526.784 391.382 526.656 391.184C526.527 390.985 526.262 390.929 526.064 391.057C525.865 391.186 525.809 391.451 525.938 391.65C526.066 391.848 526.331 391.905 526.53 391.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.075 344.95C609.274 344.821 609.33 344.556 609.201 344.357C609.073 344.159 608.808 344.102 608.61 344.231C608.411 344.36 608.355 344.625 608.484 344.824C608.612 345.022 608.877 345.078 609.075 344.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.14 441.781C451.338 441.652 451.395 441.387 451.266 441.189C451.137 440.99 450.872 440.934 450.674 441.062C450.476 441.191 450.419 441.457 450.548 441.655C450.677 441.854 450.942 441.91 451.14 441.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.747 456.949C415.946 456.82 416.002 456.555 415.873 456.356C415.745 456.158 415.48 456.101 415.281 456.23C415.083 456.359 415.027 456.624 415.155 456.823C415.284 457.021 415.549 457.078 415.747 456.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.467 450.009C405.665 449.88 405.722 449.615 405.593 449.416C405.465 449.218 405.2 449.161 405.001 449.29C404.803 449.419 404.747 449.684 404.875 449.883C405.004 450.081 405.269 450.138 405.467 450.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.356 368.147C518.554 368.019 518.61 367.753 518.482 367.555C518.353 367.356 518.088 367.3 517.89 367.429C517.691 367.557 517.635 367.823 517.764 368.021C517.892 368.22 518.157 368.276 518.356 368.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.21 412.929C488.409 412.8 488.465 412.534 488.336 412.336C488.208 412.137 487.943 412.081 487.744 412.21C487.546 412.339 487.49 412.604 487.618 412.802C487.747 413.001 488.012 413.057 488.21 412.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.187 384.051C555.385 383.922 555.441 383.657 555.313 383.458C555.184 383.26 554.919 383.203 554.721 383.332C554.523 383.461 554.466 383.726 554.595 383.925C554.724 384.123 554.989 384.18 555.187 384.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.035 326.557C608.234 326.428 608.29 326.163 608.161 325.964C608.033 325.766 607.768 325.709 607.57 325.838C607.371 325.967 607.315 326.232 607.444 326.431C607.572 326.629 607.837 326.686 608.035 326.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.239 309.65C605.437 309.521 605.493 309.256 605.365 309.057C605.236 308.859 604.971 308.802 604.773 308.931C604.575 309.06 604.518 309.325 604.647 309.524C604.775 309.722 605.04 309.779 605.239 309.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M546.63 343.305C546.894 343.133 546.97 342.779 546.798 342.514C546.626 342.249 546.273 342.174 546.009 342.346C545.744 342.518 545.669 342.872 545.84 343.136C546.012 343.401 546.365 343.476 546.63 343.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.603 326.295C535.867 326.123 535.942 325.769 535.771 325.504C535.599 325.239 535.246 325.164 534.981 325.336C534.717 325.508 534.642 325.862 534.813 326.126C534.985 326.391 535.338 326.466 535.603 326.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.37 340.568C562.569 340.439 562.625 340.174 562.496 339.975C562.368 339.777 562.103 339.72 561.904 339.849C561.706 339.978 561.65 340.243 561.778 340.442C561.907 340.64 562.172 340.697 562.37 340.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M567.92 323.684C568.184 323.512 568.259 323.158 568.088 322.894C567.916 322.629 567.563 322.554 567.298 322.725C567.034 322.897 566.959 323.251 567.13 323.516C567.302 323.78 567.655 323.856 567.92 323.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M602.632 325.302C602.896 325.13 602.971 324.776 602.8 324.512C602.628 324.247 602.275 324.172 602.01 324.343C601.746 324.515 601.671 324.869 601.842 325.134C602.014 325.399 602.367 325.474 602.632 325.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M574.945 343.972C575.21 343.8 575.285 343.446 575.114 343.181C574.942 342.917 574.588 342.841 574.324 343.013C574.06 343.185 573.984 343.539 574.156 343.804C574.328 344.068 574.681 344.144 574.945 343.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M440.238 437.288C440.503 437.117 440.578 436.763 440.406 436.498C440.235 436.233 439.881 436.158 439.617 436.33C439.353 436.501 439.277 436.855 439.449 437.12C439.621 437.385 439.974 437.46 440.238 437.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M412.313 436.706C412.577 436.535 412.652 436.181 412.481 435.916C412.309 435.651 411.956 435.576 411.691 435.748C411.427 435.92 411.352 436.273 411.523 436.538C411.695 436.803 412.048 436.878 412.313 436.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M588.163 324.489C588.428 324.318 588.503 323.964 588.331 323.699C588.16 323.434 587.806 323.359 587.542 323.531C587.277 323.702 587.202 324.056 587.374 324.321C587.545 324.586 587.899 324.661 588.163 324.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M441.251 406.327C441.516 406.156 441.591 405.802 441.419 405.537C441.248 405.272 440.894 405.197 440.63 405.369C440.365 405.541 440.29 405.894 440.462 406.159C440.633 406.424 440.987 406.499 441.251 406.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M431.685 405.733C431.949 405.562 432.024 405.208 431.853 404.943C431.681 404.678 431.328 404.603 431.063 404.775C430.799 404.947 430.724 405.3 430.895 405.565C431.067 405.83 431.42 405.905 431.685 405.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M439.712 422.31C439.976 422.138 440.052 421.784 439.88 421.519C439.709 421.255 439.355 421.179 439.091 421.351C438.826 421.523 438.751 421.877 438.923 422.141C439.094 422.406 439.448 422.482 439.712 422.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.51 412.353C454.708 412.224 454.765 411.959 454.636 411.76C454.507 411.562 454.242 411.505 454.044 411.634C453.846 411.763 453.789 412.028 453.918 412.227C454.047 412.425 454.312 412.482 454.51 412.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M647.699 339.832C647.964 339.66 648.039 339.307 647.867 339.042C647.696 338.777 647.342 338.702 647.078 338.873C646.814 339.045 646.738 339.399 646.91 339.664C647.082 339.929 647.435 340.004 647.699 339.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.961 341.458C651.159 341.329 651.216 341.064 651.087 340.865C650.959 340.667 650.694 340.61 650.495 340.739C650.297 340.868 650.241 341.133 650.369 341.332C650.498 341.53 650.763 341.587 650.961 341.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.598 331.296C655.796 331.167 655.853 330.902 655.724 330.704C655.595 330.505 655.33 330.449 655.132 330.577C654.934 330.706 654.877 330.972 655.006 331.17C655.135 331.369 655.4 331.425 655.598 331.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.948 344.031C635.146 343.902 635.202 343.637 635.074 343.439C634.945 343.24 634.68 343.184 634.482 343.312C634.283 343.441 634.227 343.707 634.356 343.905C634.484 344.104 634.749 344.16 634.948 344.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M626.828 357.478C627.093 357.306 627.168 356.952 626.996 356.688C626.825 356.423 626.471 356.347 626.207 356.519C625.942 356.691 625.867 357.045 626.039 357.31C626.21 357.574 626.564 357.65 626.828 357.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.867 355.161C618.999 355.076 619.036 354.899 618.951 354.767C618.865 354.634 618.688 354.597 618.556 354.682C618.424 354.768 618.387 354.945 618.472 355.077C618.558 355.21 618.735 355.247 618.867 355.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.034 349.643C653.167 349.557 653.204 349.38 653.118 349.248C653.033 349.116 652.856 349.078 652.724 349.164C652.592 349.25 652.554 349.426 652.64 349.559C652.726 349.691 652.902 349.729 653.034 349.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.201 315.75C705.333 315.664 705.37 315.487 705.285 315.355C705.199 315.223 705.022 315.185 704.89 315.271C704.758 315.357 704.72 315.533 704.806 315.666C704.892 315.798 705.068 315.836 705.201 315.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.895 285.864C723.027 285.778 723.064 285.601 722.979 285.469C722.893 285.337 722.716 285.299 722.584 285.385C722.452 285.471 722.415 285.647 722.5 285.78C722.586 285.912 722.763 285.95 722.895 285.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.565 297.29C743.697 297.204 743.735 297.028 743.649 296.895C743.563 296.763 743.387 296.725 743.254 296.811C743.122 296.897 743.085 297.074 743.17 297.206C743.256 297.338 743.433 297.376 743.565 297.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.472 395.428C569.604 395.342 569.642 395.165 569.556 395.033C569.47 394.9 569.294 394.863 569.162 394.949C569.03 395.034 568.992 395.211 569.078 395.344C569.163 395.476 569.34 395.513 569.472 395.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M557.499 384.822C557.632 384.736 557.669 384.56 557.583 384.427C557.498 384.295 557.321 384.257 557.189 384.343C557.057 384.429 557.019 384.606 557.105 384.738C557.191 384.87 557.367 384.908 557.499 384.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M550.783 397.018C550.915 396.932 550.953 396.755 550.867 396.623C550.781 396.491 550.605 396.453 550.472 396.539C550.34 396.625 550.303 396.802 550.388 396.934C550.474 397.066 550.651 397.104 550.783 397.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M567.996 406.262C568.128 406.176 568.165 405.999 568.079 405.867C567.994 405.735 567.817 405.697 567.685 405.783C567.553 405.869 567.515 406.046 567.601 406.178C567.687 406.31 567.863 406.348 567.996 406.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M618.731 359.675C618.863 359.589 618.901 359.412 618.815 359.28C618.729 359.147 618.553 359.11 618.42 359.196C618.288 359.281 618.251 359.458 618.336 359.59C618.422 359.723 618.599 359.76 618.731 359.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M658.146 358.579C658.278 358.493 658.316 358.317 658.23 358.184C658.144 358.052 657.968 358.014 657.835 358.1C657.703 358.186 657.666 358.363 657.752 358.495C657.837 358.627 658.014 358.665 658.146 358.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M702.537 326.331C702.669 326.245 702.706 326.068 702.62 325.936C702.535 325.804 702.358 325.766 702.226 325.852C702.094 325.938 702.056 326.115 702.142 326.247C702.228 326.379 702.404 326.417 702.537 326.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M576.598 382.286C576.73 382.2 576.768 382.023 576.682 381.891C576.596 381.759 576.42 381.721 576.288 381.807C576.156 381.893 576.118 382.069 576.204 382.202C576.289 382.334 576.466 382.372 576.598 382.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.247 333.588C623.379 333.502 623.416 333.326 623.33 333.193C623.245 333.061 623.068 333.023 622.936 333.109C622.804 333.195 622.766 333.372 622.852 333.504C622.938 333.636 623.114 333.674 623.247 333.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.786 309.166C659.918 309.08 659.955 308.904 659.869 308.771C659.784 308.639 659.607 308.601 659.475 308.687C659.343 308.773 659.305 308.95 659.391 309.082C659.477 309.214 659.653 309.252 659.786 309.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.262 366.203C621.394 366.117 621.432 365.941 621.346 365.808C621.26 365.676 621.084 365.639 620.952 365.724C620.82 365.81 620.782 365.987 620.868 366.119C620.953 366.252 621.13 366.289 621.262 366.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M604.512 377.087C604.644 377.001 604.682 376.824 604.596 376.692C604.51 376.56 604.334 376.522 604.202 376.608C604.07 376.694 604.032 376.87 604.118 377.003C604.203 377.135 604.38 377.173 604.512 377.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M575.266 374.98C575.398 374.894 575.436 374.718 575.35 374.585C575.264 374.453 575.088 374.416 574.956 374.501C574.824 374.587 574.786 374.764 574.872 374.896C574.957 375.029 575.134 375.066 575.266 374.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M631.284 336.54C631.416 336.454 631.453 336.277 631.368 336.145C631.282 336.013 631.105 335.975 630.973 336.061C630.841 336.147 630.804 336.323 630.889 336.456C630.975 336.588 631.152 336.626 631.284 336.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M628.282 368.111C628.414 368.026 628.451 367.849 628.366 367.717C628.28 367.584 628.103 367.547 627.971 367.633C627.839 367.718 627.802 367.895 627.887 368.027C627.973 368.16 628.15 368.197 628.282 368.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M600.88 389.32C601.012 389.234 601.05 389.057 600.964 388.925C600.879 388.792 600.702 388.755 600.57 388.841C600.438 388.926 600.4 389.103 600.486 389.235C600.572 389.368 600.748 389.405 600.88 389.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M583.539 377.777C583.671 377.691 583.708 377.515 583.623 377.382C583.537 377.25 583.36 377.212 583.228 377.298C583.096 377.384 583.059 377.561 583.144 377.693C583.23 377.825 583.407 377.863 583.539 377.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M731.904 280.352C732.036 280.267 732.073 280.09 731.988 279.958C731.902 279.825 731.725 279.788 731.593 279.874C731.461 279.959 731.424 280.136 731.509 280.268C731.595 280.401 731.772 280.438 731.904 280.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M687.012 295.56C687.144 295.474 687.182 295.297 687.096 295.165C687.01 295.033 686.834 294.995 686.702 295.081C686.57 295.167 686.532 295.344 686.618 295.476C686.703 295.608 686.88 295.646 687.012 295.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M732.12 294.85C732.252 294.764 732.289 294.588 732.204 294.455C732.118 294.323 731.941 294.285 731.809 294.371C731.677 294.457 731.64 294.634 731.725 294.766C731.811 294.898 731.988 294.936 732.12 294.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M672.978 336.344C673.242 336.172 673.317 335.818 673.146 335.554C672.974 335.289 672.621 335.213 672.356 335.385C672.092 335.557 672.017 335.911 672.188 336.176C672.36 336.44 672.713 336.516 672.978 336.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M682.44 319.984C682.704 319.812 682.779 319.458 682.608 319.193C682.436 318.928 682.083 318.853 681.818 319.025C681.554 319.197 681.479 319.551 681.65 319.815C681.822 320.08 682.175 320.155 682.44 319.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.886 311.676C677.084 311.547 677.141 311.281 677.012 311.083C676.884 310.885 676.619 310.828 676.42 310.957C676.222 311.086 676.166 311.351 676.294 311.549C676.423 311.748 676.688 311.804 676.886 311.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.681 347.559C676.879 347.431 676.936 347.165 676.807 346.967C676.678 346.768 676.413 346.712 676.215 346.841C676.017 346.969 675.96 347.235 676.089 347.433C676.218 347.632 676.483 347.688 676.681 347.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.227 300.733C759.425 300.604 759.481 300.339 759.353 300.14C759.224 299.942 758.959 299.885 758.761 300.014C758.563 300.143 758.506 300.408 758.635 300.607C758.764 300.805 759.029 300.862 759.227 300.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.292 397.564C601.49 397.436 601.547 397.17 601.418 396.972C601.289 396.773 601.024 396.717 600.826 396.846C600.628 396.974 600.572 397.24 600.7 397.438C600.829 397.637 601.094 397.693 601.292 397.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.899 412.732C566.097 412.603 566.153 412.338 566.025 412.139C565.896 411.941 565.631 411.885 565.433 412.013C565.235 412.142 565.178 412.407 565.307 412.606C565.435 412.804 565.7 412.861 565.899 412.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.619 405.792C555.818 405.663 555.874 405.398 555.745 405.199C555.617 405.001 555.352 404.944 555.153 405.073C554.955 405.202 554.899 405.467 555.027 405.666C555.156 405.864 555.421 405.921 555.619 405.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.507 323.93C668.705 323.801 668.762 323.536 668.633 323.337C668.504 323.139 668.239 323.082 668.041 323.211C667.843 323.34 667.787 323.605 667.915 323.804C668.044 324.002 668.309 324.059 668.507 323.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.363 368.712C638.561 368.583 638.617 368.318 638.489 368.119C638.36 367.921 638.095 367.864 637.897 367.993C637.698 368.122 637.642 368.387 637.771 368.586C637.899 368.784 638.164 368.841 638.363 368.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.339 339.834C705.537 339.705 705.594 339.44 705.465 339.242C705.336 339.043 705.071 338.987 704.873 339.115C704.675 339.244 704.619 339.51 704.747 339.708C704.876 339.907 705.141 339.963 705.339 339.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.188 282.34C758.386 282.211 758.442 281.946 758.314 281.748C758.185 281.549 757.92 281.493 757.722 281.621C757.523 281.75 757.467 282.016 757.596 282.214C757.724 282.413 757.989 282.469 758.188 282.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.391 265.432C755.589 265.303 755.645 265.038 755.517 264.839C755.388 264.641 755.123 264.584 754.925 264.713C754.727 264.842 754.67 265.107 754.799 265.306C754.928 265.504 755.193 265.561 755.391 265.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M696.778 299.088C697.043 298.916 697.118 298.562 696.947 298.297C696.775 298.033 696.422 297.957 696.157 298.129C695.893 298.301 695.817 298.655 695.989 298.92C696.161 299.184 696.514 299.26 696.778 299.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.755 282.079C686.019 281.907 686.095 281.553 685.923 281.288C685.751 281.024 685.398 280.948 685.134 281.12C684.869 281.292 684.794 281.646 684.966 281.91C685.137 282.175 685.491 282.251 685.755 282.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.522 296.351C712.72 296.223 712.776 295.957 712.648 295.759C712.519 295.56 712.254 295.504 712.056 295.633C711.858 295.761 711.801 296.027 711.93 296.225C712.059 296.424 712.324 296.48 712.522 296.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M718.07 279.467C718.335 279.295 718.41 278.942 718.239 278.677C718.067 278.412 717.713 278.337 717.449 278.509C717.185 278.68 717.109 279.034 717.281 279.299C717.453 279.564 717.806 279.639 718.07 279.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M752.785 281.085C753.05 280.913 753.125 280.56 752.953 280.295C752.782 280.03 752.428 279.955 752.164 280.127C751.9 280.298 751.824 280.652 751.996 280.917C752.167 281.182 752.521 281.257 752.785 281.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M725.1 299.755C725.364 299.583 725.439 299.229 725.268 298.965C725.096 298.7 724.743 298.625 724.478 298.796C724.214 298.968 724.139 299.322 724.31 299.587C724.482 299.852 724.835 299.927 725.1 299.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M590.39 393.072C590.654 392.9 590.729 392.546 590.558 392.281C590.386 392.016 590.033 391.941 589.768 392.113C589.504 392.285 589.429 392.639 589.6 392.903C589.772 393.168 590.125 393.243 590.39 393.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M562.467 392.49C562.731 392.318 562.807 391.964 562.635 391.699C562.463 391.434 562.11 391.359 561.846 391.531C561.581 391.703 561.506 392.057 561.678 392.321C561.849 392.586 562.203 392.661 562.467 392.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M738.317 280.273C738.581 280.101 738.656 279.747 738.485 279.482C738.313 279.217 737.96 279.142 737.695 279.314C737.431 279.486 737.356 279.84 737.527 280.104C737.699 280.369 738.052 280.444 738.317 280.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M591.403 362.111C591.668 361.939 591.743 361.585 591.571 361.32C591.4 361.055 591.046 360.98 590.782 361.152C590.518 361.324 590.442 361.678 590.614 361.942C590.785 362.207 591.139 362.282 591.403 362.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M581.839 361.517C582.103 361.345 582.179 360.991 582.007 360.726C581.835 360.461 581.482 360.386 581.218 360.558C580.953 360.73 580.878 361.084 581.049 361.348C581.221 361.613 581.574 361.688 581.839 361.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M589.862 378.093C590.127 377.921 590.202 377.567 590.031 377.302C589.859 377.038 589.505 376.962 589.241 377.134C588.977 377.306 588.901 377.66 589.073 377.925C589.245 378.189 589.598 378.265 589.862 378.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.661 368.136C604.86 368.008 604.916 367.742 604.787 367.544C604.659 367.345 604.394 367.289 604.196 367.418C603.997 367.546 603.941 367.812 604.069 368.01C604.198 368.209 604.463 368.265 604.661 368.136Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_50_1125",
    x: 72.3656,
    y: 72.1991,
    width: 829.97,
    height: 760.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.35,
    result: "effect1_foregroundBlur_50_1125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_50_1125",
    x: 367.458,
    y: 152.887,
    width: 450.65,
    height: 422.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_50_1125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_1125",
    x1: 14.3519,
    y1: 0,
    x2: 14.3519,
    y2: 598.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_1125",
    x1: 10.6796,
    y1: 0,
    x2: 10.6796,
    y2: 257.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLight);
export default __webpack_public_path__ + "static/media/right-light.8e6b8b2c2799b522e7ea652dc36eef22.svg";
export { ForwardRef as ReactComponent };